<template>
  <fieldset class="account__form-section account__form-section--wide">
    <legend class="account__form-section-title">{{ formSection }}</legend>
    <div class="input-group__wrap input-group__wrap--wide">
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label for="apiKey" class="input-group__label">API Key</label>
        <input
          id="apiKey"
          readonly
          class="input-group__input input-group__input--extra-wide input-group__input--wide"
          v-model="apiKey"
        />
        <LoadingButton
          class="layout--margin-top-sm"
          v-clipboard="apiKey"
          v-clipboard:success="copyAPIKey"
          :doneLoading="apiKeyCopied"
          label="Copy"
          doneLoadingLabel="Copied!"
        />
      </div>
    </div>
    <div class="input-group__wrap input-group__wrap--wide">
      <div class="input-group__field-wrap input-group__field-wrap--wide">
        <label
          for="secretKey"
          class="input-group__label layout--margin-bottom-none"
          >Secret Key</label
        >
        <em>Security note: Do not share secret key publicly.</em>
        <input
          id="secretKey"
          readonly
          class="input-group__input input-group__input--extra-wide input-group__input--wide layout--margin-top-sm"
          v-model="secretKey"
        />
        <LoadingButton
          class="layout--margin-top-sm"
          v-clipboard="secretKey"
          v-clipboard:success="copySecretKey"
          :doneLoading="secretKeyCopied"
          label="Copy"
          doneLoadingLabel="Copied!"
        />
      </div>
    </div>
    <div class="layout--flex-start input-group__warning">
      <font-awesome-icon icon="exclamation-circle" size="lg" />
      <div
        id="resetSecretKeyWarning"
        class="input-group__warning layout--margin-left-xs"
      >
        Warning: changing or resetting your secret key will invalidate any
        existing URL tokens.
      </div>
    </div>
    <LoadingButton
      :event="resetKey"
      :loading="$wait.is('resetting secret key')"
      :doneLoading="done"
      label="Reset Secret Key"
      loadingLabel="Resetting..."
      doneLoadingLabel="Finished resetting!"
      secondary
    />
  </fieldset>
</template>

<script>
const formSection = "Account Keys";

import { mapGetters } from "vuex";
import { mapWaitingActions } from "vue-wait";

import LoadingButton from "../../../components/LoadingButton";
import IconAlert from "../../../assets/icons/icon-alert.svg";

export default {
  name: "AccountKeys",
  components: {
    IconAlert,
    LoadingButton,
  },
  data() {
    return {
      formSection,
      done: false,
      apiKeyCopied: false,
      secretKeyCopied: false,
    };
  },
  computed: {
    ...mapGetters("account", ["apiKey", "secretKey"]),
  },
  methods: {
    ...mapWaitingActions("account", { resetAPIKeys: "resetting secret key" }),
    resetKey: function() {
      this.resetAPIKeys().then(() => {
        this.done = true;
        this.secretKeyCopied = false;
      });
    },
    copyAPIKey: function() {
      this.apiKeyCopied = true;
    },
    copySecretKey: function() {
      this.secretKeyCopied = true;
    },
  },
};
</script>

<style></style>
